import { Injectable, inject } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable, of } from "rxjs";
import { catchError, shareReplay } from "rxjs/operators";
import { AppSettings } from "app/app.settings";
import { FeatureFlags } from "@app/models/feature-flags.enum";

@Injectable({
   providedIn: "root"
})
export class FeatureFlagService {
   private httpClient = inject(HttpClient);
   private appSettings = inject(AppSettings);

   private readonly baseUri: string;
   private readonly endpoint: string;
   private readonly cache = new Map<FeatureFlags, Observable<boolean>>();

   constructor() {
      this.baseUri = `${this.appSettings.baseCoreApiUrl}`;
      this.endpoint = `feature-flags`;
   }

   public isFeatureEnabled(code: FeatureFlags): Observable<boolean> {
      if (!this.cache.has(code)) {
         this.cache.set(
            code,
            this.httpClient
               .get<boolean>(`${this.baseUri}/${this.endpoint}/${code}`)
               .pipe(
                  catchError(() => of(false)),
                  shareReplay({ bufferSize: 1, refCount: false })
               )
         );
      }
      return this.cache.get(code);
   }

   public clearCache(): void {
      this.cache.clear();
   }
}
